import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { CustomTextField } from "@totalsoft/rocket-webapp-components-deprecated";
import { Button, CircularProgress, Grid, IconButton, Link, makeStyles, Tooltip } from "@material-ui/core";
import { Autorenew, Search } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { get, set } from "@totalsoft/change-tracking-react";
import { onTextBoxChange } from "utils/propertyChangeAdapters";
import clientPageStyle from "features/client/styles";
import { emptyString } from "constants/defaultValues";

const useStyles = makeStyles(clientPageStyle);

function ExtendedFilters({ setExtended, filterLens, onReset, onSearch, loading }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleExtended = useCallback(() => {
    setExtended(false);
  }, [setExtended]);

  return (
    <Grid container spacing={2}>
      <Grid item container sm={12} md={11} spacing={2} alignItems="center">
        <Grid item container xs={12} md={4} direction="column" justifyContent="center">
          <Grid item xs>
            <CustomTextField
              fullWidth
              label={t("Client.CompanyName")}
              value={(filterLens.companyName |> get) || emptyString}
              onChange={filterLens.companyName |> set |> onTextBoxChange}
            />
          </Grid>
          <Grid item xs>
            <CustomTextField
              fullWidth
              label={t("Client.TaxIdNumber")}
              value={(filterLens.taxId |> get) || emptyString}
              onChange={filterLens.taxId |> set |> onTextBoxChange}
            />
          </Grid>
        </Grid>
        <Grid item container xs={12} md={4} direction="column" justifyContent="center">
          <Grid item xs>
            <CustomTextField
              fullWidth
              label={t("Client.Street1")}
              value={(filterLens.street1 |> get) || emptyString}
              onChange={filterLens.street1 |> set |> onTextBoxChange}
            />
          </Grid>
          <Grid item xs>
            <CustomTextField
              fullWidth
              label={t("Client.Street2")}
              value={(filterLens.street2 |> get) || emptyString}
              onChange={filterLens.street2 |> set |> onTextBoxChange}
            />
          </Grid>
        </Grid>
        <Grid item container xs={12} md={4} direction="column" justifyContent="center">
          <Grid item xs>
            <CustomTextField
              fullWidth
              label={t("Client.City")}
              value={(filterLens.city |> get) || emptyString}
              onChange={filterLens.city |> set |> onTextBoxChange}
            />
          </Grid>
          <Grid item xs>
            <CustomTextField
              fullWidth
              label={t("Client.Zip")}
              value={(filterLens.zip |> get) || emptyString}
              onChange={filterLens.zip |> set |> onTextBoxChange}
            />
          </Grid>
          <Grid item xs>
            <CustomTextField
              fullWidth
              label={t("Client.State")}
              value={(filterLens.state |> get) || emptyString}
              onChange={filterLens.state |> set |> onTextBoxChange}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={1} container justifyContent="flex-end" alignItems="center">
        <IconButton color="default" onClick={onReset} style={{ marginRight: 10 }}>
          <Tooltip title={t("General.ResetFilter")}>
            <Autorenew fontSize="small" />
          </Tooltip>
        </IconButton>
        <Button
          id="clientSearch_SearchBtn"
          right="true"
          variant="contained"
          color="primary"
          onClick={onSearch}
          endIcon={loading ? <CircularProgress size={20} color={"inherit"} /> : <Search />}
        >
          {t("General.Search")}
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Link
          id="clientSearch_extendedSearch"
          underline="always"
          color="primary"
          onClick={handleExtended}
          className={classes.cursorLink}
        >
          {t("Client.BasicSearch")}
        </Link>
      </Grid>
    </Grid>
  );
}

ExtendedFilters.propTypes = {
  setExtended: PropTypes.func.isRequired,
  filterLens: PropTypes.object.isRequired,
  onReset: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ExtendedFilters;
